/**
 * Metrics & Analytics Page
 * Access: All roles
 *
 * Detailed metrics tracking and visualization:
 * - Users: View personal health trends
 * - Coaches: Analyze client progress
 * - Admins: View system-wide analytics
 */

export function MetricsPage() {
  return (
    <div className="p-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 text-text-dark">
          Metrics & Analytics
        </h1>

        <div className="card mb-6">
          <h2 className="text-xl font-semibold mb-4 text-text-dark">
            Key Metabolic Markers
          </h2>

          <div className="grid gap-6 md:grid-cols-3">
            <div className="p-4 rounded-lg bg-beige">
              <div className="text-sm mb-1 text-text-secondary">
                Fasting Glucose
              </div>
              <div className="text-2xl font-bold text-primary">-- mg/dL</div>
              <div className="text-xs mt-1 text-text-secondary">
                Target: 70-100 mg/dL
              </div>
            </div>

            <div className="p-4 rounded-lg bg-beige">
              <div className="text-sm mb-1 text-text-secondary">HbA1c</div>
              <div className="text-2xl font-bold text-secondary">-- %</div>
              <div className="text-xs mt-1 text-text-secondary">
                Target: {'<'}5.7%
              </div>
            </div>

            <div className="p-4 rounded-lg bg-beige">
              <div className="text-sm mb-1 text-text-secondary">
                Triglycerides
              </div>
              <div className="text-2xl font-bold text-accent-orange">
                -- mg/dL
              </div>
              <div className="text-xs mt-1 text-text-secondary">
                Target: {'<'}150 mg/dL
              </div>
            </div>
          </div>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          <div className="card">
            <h2 className="text-xl font-semibold mb-4 text-text-dark">
              Recent Entries
            </h2>
            <div className="text-center py-12 text-text-secondary">
              <p>No metric entries yet. Start tracking to see your trends.</p>
            </div>
          </div>

          <div className="card">
            <h2 className="text-xl font-semibold mb-4 text-text-dark">
              Progress Charts
            </h2>
            <div className="text-center py-12 text-text-secondary">
              <p>Charts will appear here once you have tracked metrics.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
